import { render } from "./templateCardView.vue?vue&type=template&id=164bb0b6"
import script from "./templateCardView.vue?vue&type=script&lang=js"
export * from "./templateCardView.vue?vue&type=script&lang=js"

import "./templateCardView.vue?vue&type=style&index=0&id=164bb0b6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__